import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import './../../../../assets/js/smtp.js' //'./../../../assets/smtp.js' ; //le chemin peut changer
declare let Email : any;

@Component({
  selector: 'app-home-page-thirteen',
  templateUrl: './home-page-thirteen.component.html',
  styleUrls: ['./home-page-thirteen.component.scss']
})
export class HomePageThirteenComponent implements OnInit {
  //model: Model = new Model();
  sub = 'sujet du mail';
  name = 'john doe';
  mail = 'johndoe@anonyme.com';
  message = 'Test message from app';

  constructor(
    // private profile: ProfileService, private snotify: SnotifyService
  ) { }

  ngOnInit(): void {
  }

  onSubmit() {
    //port:2525
    Email.send({
    Host : 'smtp.elasticemail.com',
    Port: 2525,
    Username : 'mtr.fosk@gmail.com',
    Password : '10BA7F709E59BF3006B289FDAF4F6C8EE150',
    To : 'work.fosk@gmail.com',
    From : 'mtr.fosk@gmail.com',
    Subject : this.sub,
    Body : `
    <i>This is sent as a feedback from my resume page.</i> <br/> <b>Name: </b>${this.name} <br /> <b>Email: </b>${this.mail}<br /> <b>Subject: </b>${this.sub}<br /> <b>Message:</b> <br /> ${this.message} <br><br> <b>~End of Message.~</b> `
    }).then( message => {console.log(message);  } );
      
  }

}
